import {useRouteMatches} from '@github-ui/react-core/future/query-route'
import type {RepoRouteHandle} from '../routes/repo-route-handle'

export function useSubAppName() {
  const matches = useRouteMatches()
  const appName =
    matches
      .map(match => (match.handle as RepoRouteHandle | undefined)?.repoSubAppName)
      .find(name => name !== undefined) ?? 'repo'
  return appName
}
